import * as React from "react";
import cx from "classnames";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes, Intent } from "@blueprintjs/core";
import { Button, Card, Elevation,Icon, Overlay,H4 } from "@blueprintjs/core";
import { Checkbox } from '@material-ui/core';
import  {MSG_VISIO} from "../MessagesVisio.js"
import{HomeProps} from './Home.tsx'
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import MyToaster from './components/MyToaster.tsx';
import { type, userInfo } from "os";
import { throws } from "assert";

export type type_home = {
value:undefined,
isValidSignin:undefined,
isValidLogin:undefined
}

export default class CardPourEnseignantCnx extends React.Component  <{}> {
 // class_selected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_SUCCESS;
 // class_noselected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING;
  msg_visio=MSG_VISIO;
  state = {
    name: '',
    dcnx:false,
    selected_mesdocuments:false,
    lstStudent:false,
    selected_visio:false,
    selected_reduire:640,
    nb_student:0,
    must_refresh:false,
    selected_student:[{}]
  }  
  
  

  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    console.log(this.props);
    this.setState({nb_student:this.props.nb_student_cnx})
    var obj=[];
    this.props.datastudent.map((item, idx)=>{
      var item2=item;
      item2.selected=true;
      if(item2.etat=="En ligne") obj.push(item2) 
     });
     this.setState({selected_student:obj});
    //this.handleU();
   
    
  }
 
  componentDidUpdate(prevProps, prevState) {
    if(this.props.selected_visio!=this.state.selected_visio)this.setState({selected_visio:this.props.selected_visio})
   if(this.props.nb_student_cnx!=this.state.nb_student)
   {
    this.setState({nb_student:this.props.nb_student_cnx})
    var obj=[];
    this.props.datastudent.map((item, idx)=>{
      var item2=item;
      item2.selected=true;
      if(item2.etat=="En ligne") obj.push(item2) 
     });
     this.setState({selected_student:obj});
     
   }
   if(this.state.must_refresh==true) this.setState({must_refresh:false});
    /* if (prevState.name !== prevProps.usernickname.nickname) {
      this.handleUpdateName();
    }*/
  }
 /* handleUpdateName = () => {
    this.setState({ name: this.props.usernickname.nickname });
    const item=document.getElementById('id_name');
    item.value=this.props.usernickname.nickname;
  }*/
   render() {
    
    const {nom_student,handleOpenVisio,handleSelectPage}=this.props;
    const targetClassName_document = cx({'bp3-outlined':! this.state.selected_mesdocuments}, Classes.LARGE,  {'bp3-intent-success': this.state.selected_mesdocuments} );
    const targetClassName_lstStudent = cx({'bp3-outlined':! this.state.lstStudent}, Classes.LARGE,  {'bp3-intent-success': this.state.lstStudent} );
    const targetClassName_reduire = cx(Classes.OUTLINED, Classes.LARGE,  {'bp3-intent-danger': false} );
    const targetClassName_visio = cx({'bp3-outlined':! this.state.selected_visio}, Classes.LARGE,  {'bp3-intent-success': this.state.selected_visio} );
    return(
     <div style={{paddingTop:'50px',position:'relative',zIndex:10,width:'470px'}}>
     {nom_student!=""? <Card style={{width:this.state.selected_reduire,margin:4,backgroundColor:'#e4eff7',padding: '10px'} } interactive={true} elevation={Elevation.TWO}>
     <Icon onClick={(ev)=>{ev.preventDefault();if(this.state.selected_reduire>60)this.setState({selected_reduire:40});else this.setState({selected_reduire:640});}} icon="info-sign" intent={Intent.PRIMARY} size={20}></Icon>
     {this.state.selected_reduire >60 ?<span><a onClick={(ev)=>{ev.preventDefault();this.setState({dcnx:true});}} style={{marginLeft:8,marginRight:8}}>Dernier étudiant de connecté: {nom_student}</a>
     <Button  onClick={(ev)=>{ev.preventDefault();if(!this.state.lstStudent){this.setState({lstStudent:true});}else{handleOpenVisio(this.msg_visio.FERMER_VISIO,"");this.setState({lstStudent:false});}}}className={targetClassName_lstStudent} icon="inherited-group" title="Voir mes étudiants connectés"></Button>
     <Button  onClick={(ev)=>{ev.preventDefault();if(!this.state.selected_visio){handleOpenVisio(this.msg_visio.OUVRIR_VISIO,"");this.setState({selected_visio:true});}else{handleOpenVisio(this.msg_visio.FERMER_VISIO,"");this.setState({selected_visio:false});}}}className={targetClassName_visio} icon="eye-open" title="Entrez dans la classe"></Button>
     <Button  onClick={(ev)=>{ev.preventDefault();if(this.state.selected_reduire==640){this.setState({selected_reduire:40});}}} className={targetClassName_reduire } icon="arrow-left" title="Réduire"></Button>
      </span>:<div></div>}
     </Card>:<div></div>}
     <Overlay isOpen={this.state.lstStudent} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
      
        <H4>Liste de vos étudiants dans la classe</H4>
        <ul>
            {this.state.selected_student.map((item, idx) => (
              <div style={{height: item.etat=="En ligne"?'30px':'0px'}}>{item ? item.etat=="En ligne"?<span ><Checkbox  key={idx} checked={item.selected} onClick={(ev)=>{item.selected=!item.selected;console.log(item);this.setState({must_refresh:true});}} ></Checkbox><span><b>{item.nickname}</b>:  est en ligne</span></span>:null:null}</div>
            ))}
          </ul>
          <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.ALL_IN_VISIO,"");handleOpenVisio(this.msg_visio.OUVRIR_VISIO,"");}}>Mettre les étudiants en Visio Conférence</Button>
          <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.OUVRIR_CAMERA,this.state.selected_student);}}>Voir leurs cameras</Button>
          <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.FERMER_CAMERA,this.state.selected_student);}}>éteindre leurs cameras</Button>
          <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.OUVRIR_MICROPHONE,this.state.selected_student);}}>Entendre les étudiants</Button>
          <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.FERMER_MICROPHONE,this.state.selected_student);}}>couper les microphones</Button>
        <p></p>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({lstStudent:false});}}>Fermer</Button>
        
      </div>
      </Overlay>
     </div>);
}
}
